// Reference backend's `Kics.Shared.CalculationEngine.Domain.Common.LayerMaterialTypeModels.cs` for backend strings
export enum LayerMaterialTypeKeys {
  GenericInsulation = 'GenericInsulation',
  InvertedInsulation = 'InvertedInsulation',
  NonInsulation = 'NonInsulation',
  UnventilatedAirspace = 'UnventilatedAirspace',
  WellVentilatedAirspace = 'WellVentilatedAirspace',
}
